import React from "react";
import { Checkbox as MUICheckbox } from "@mui/material";
import styled from "styled-components";

const StyledCheckbox = styled(MUICheckbox)`
  input {
    position: absolute;
    :disabled {
      opacity: 0;
    }
  }
`;

export const Checkbox = ({
  checked,
  onChange,
  color = "primary",
  ariaLabel,
  id,
  disabled,
  disableRipple,
}) => {
  return (
    <StyledCheckbox
      id={id}
      checked={checked}
      onChange={onChange}
      color={color}
      disabled={disabled}
      disableRipple={disableRipple}
      inputProps={{ "aria-label": ariaLabel || `${id} checkbox` }}
    />
  );
};
